import { Box, useTheme } from "@mui/material";
import { MultiImpactTableData } from "../../../../context/utils/impactData/formatComparisonTable";
import { Fragment } from "react/jsx-runtime";
import { TableBlockHeader } from "../Common/TableBlockHeader";
import { OneActionRow } from "./OneActionRow";
import { MultipleActionsRows } from "./MultipleActionsRows";

type MultivalueComparisonTableProps = {
    multiImpactTable: MultiImpactTableData[];
};

export const MultivalueComparisonTable = (props: MultivalueComparisonTableProps) => {
    const theme = useTheme();
    const { multiImpactTable } = props;

    return (
        <Fragment>
            {multiImpactTable.map((impactTable, position) => {
                const {
                    subpropertyValue,
                    formattedSummedActionsImpact,
                    shouldDisplaySummedImpact,
                    propertiesWithComposedImpactsNames,
                    multivalueParent,
                    hasMultipleActions,
                    extendedImpactData,
                } = impactTable;

                return (
                    <Box
                        key={`${multivalueParent?.id}-${impactTable.position}`}
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "12px",
                            border: `1px solid ${theme.custom.grey[400]}`,
                        }}
                    >
                        <TableBlockHeader
                            parentName={multivalueParent?.name ?? multivalueParent?.title}
                            propertyName={subpropertyValue}
                            hasMultipleActions={hasMultipleActions}
                            propertiesWithMultipleActions={propertiesWithComposedImpactsNames}
                            position={position}
                        />

                        {hasMultipleActions ?
                            <MultipleActionsRows
                                extendedImpactData={extendedImpactData}
                                total={shouldDisplaySummedImpact ? formattedSummedActionsImpact : null}
                            />
                        :   <OneActionRow
                                extendedImpactData={extendedImpactData}
                                total={shouldDisplaySummedImpact ? formattedSummedActionsImpact : null}
                            />
                        }
                    </Box>
                );
            })}
        </Fragment>
    );
};
